import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MobileOtpService {
  constructor(private http: HttpClient) {}

  generatePasscode(phoneNumber) {
    const phoneNum = this.formmatPhoneNumber(phoneNumber);
    const url = `${environment.backend_server_url_account}/guest/${phoneNum}/passcode`;
    return this.http.get(url);
  }

  validatePasscode(phoneNumber, passcode, requestBody) {
    const phoneNum = this.formmatPhoneNumber(phoneNumber);
    const url = `${environment.backend_server_url_account}/guest/${phoneNum}/passcode/${passcode}/verify`;
    return this.http.post(url, requestBody);
  }
  formmatPhoneNumber(phoneNumber) {
    if (phoneNumber.indexOf('+1') > -1 && phoneNumber.length === 12) {
      return phoneNumber;
    } else if (phoneNumber.length === 11) {
      return `+${phoneNumber}`;
    }
    return `+1${phoneNumber}`;
  }
}
